import axios from "axios";
import moment from "moment";
import { BASE_URL, IMAGE_CRM_BASE_URL } from "../config/api_collection";

const CRM_BASE_URL = `${BASE_URL}/inspirenetz-api/api/0.9/json/merchant/customer`;
const CRM_EVENTLOG = `${BASE_URL}/inspirenetz-api/api/0.9/json/eventlogs`;
const CRM_SEARCH_CUSTOMER = `${BASE_URL}/inspirenetz-api/api/0.9/json/merchant/customer/search`;
const PROMOTION_PREFERENCE_FOR_USER = `${BASE_URL}/api/ibe/crm/users/promotion`;
const NEWS_SUBSCRIBE = `${BASE_URL}/api/newsletter/subscribe`;
const UPLOAD_PROFILE_IMAGE_URL = `${IMAGE_CRM_BASE_URL}/inspirenetz-api/upload/image`;
const SAVE_GUEST_USER_IN_CRM = `${BASE_URL}/api/ibe/crm/users`;

export const getHeaderData = () => {
  const cognitoToken = sessionStorage.getItem("auth-access-token");
  const sessionToken = localStorage.getItem("token") || "";

  const headers: any = {
    authorization: sessionToken
  };

  if (cognitoToken) {
    headers["x-session-token"] = `Bearer ${cognitoToken}`;
  }
  
  return headers;
};

export const fetchCustomerData = (id) => {
  const headers = getHeaderData();
  // if(headers && Object.keys(headers).length === 0){
  if (!headers["x-session-token"]) {
    return null;
  }  

  //Make request if User is authenticated
  else
  {
  headers.crm_id = id;

  const response = axios
    .get(`${CRM_BASE_URL}/1001`, { headers })
    .then(
      (res) => res?.data?.data,
      (rejected) => {}
    )
    .catch((error) => console.warn(error));

  return response;
  // }
 };
}

// communication and privacycentre modal
export const updatePreferences = (id, data) => {
  const headers = getHeaderData();
  headers.crm_id = id;
  const res = axios
    .post(
      `${CRM_BASE_URL}/detail/update`,
      {
        cusCustomerNo: id,
        cusAttrs: {
          ...data
        }
      },
      { headers }
    )
    .then(
      (res) => {
        if (res.status === 200) {
          return true;
        }
        return false;
      },
      (rejected) => console.warn(rejected)
    )
    .catch((error) => console.warn(error));
  return res;
};
export const editCustomerData = (id, data) => {
  const headers = getHeaderData();
  headers.crm_id = id;
  const response = axios
    .post(
      `${CRM_BASE_URL}/detail/update`,
      {
        cusCustomerNo: id,
        ...data,
        CP_EMAIL_ALTERNATE: { ...data.CP_EMAIL_ALTERNATE }
      },
      { headers }
    )
    .then(
      (res) => res,
      (rejected) => console.warn(rejected)
    )
    .catch((error) => console.warn(error));
  return response;
};

export const deleteCustomer = (id: number) => {
  const headers = getHeaderData();
  try {
    const res =  axios.post(
      `${CRM_BASE_URL}/delete/profile`,
      {
        cusCustomerNo: id,
      },
      { headers }
    );
    return res;
  }catch(error){
      console.warn(error);
      return null;
  }
};
export const updateTravelPreference = (id, data) => {
  const headers = getHeaderData();
  headers.crm_id = id;
  const res = axios
    .post(
      `${CRM_BASE_URL}/detail/update`,
      {
        cusCustomerNo: id,
        ...data
      },
      { headers }
    )
    .then(
      (res) => {
        if (res?.status === 200) {
          return true;
        }
        return false;
      },
      (rejected) => console.warn(rejected)
    )
    .catch((error) => console.warn(error));
  return res;
};

export const addTraveller = (id, data, updateId = null) => {
  const headers = getHeaderData();
  const payload = {
    searchText: id,
    nomineeSet: [updateId ? { cunId: updateId, ...data } : { ...data }]
  };

  const res = axios
    .post(`${CRM_BASE_URL}/nominee/update`, payload, { headers })
    .then(
      (res) => {
        if (res.status === 200) {
          return true;
        }
        return false;
      },
      (rejected) => console.warn(rejected)
    )
    .catch((error) => console.warn(error));
  return res;
};

export const uploadProfileImage = (params: any) => {
  try {
    const headers = getHeaderData();
    headers["Content-Type"] = "multipart/form-data";
    const response = axios.post(
      `${UPLOAD_PROFILE_IMAGE_URL}`,
      {
        username: params.username,
        authentication: params.authentication,
        imagetype: params.imagetype,
        filename: params.filename,
        file: params.file
      },
      {
        headers
      }
    );
    return response;
  } catch (error) {
    console.warn(error.message);
  }
};
export const deleteTraveller = (id, cunId) => {
  const headers = getHeaderData();
  const res = axios
    .post(
      `${CRM_BASE_URL}/nominee/update`,
      {
        searchText: id,
        nomineeSet: [{ cunId, isRemove: 1 }]
      },
      { headers }
    )
    .then(
      (res) => {
        if (res.status === 200) {
          return true;
        }
        return false;
      },
      (rejected) => console.warn(rejected)
    )
    .catch((error) => console.warn(error));
  return res;
};
export const addBusinessProfile = (id, data, updateId = null) => {
  const headers = getHeaderData();
  const payload = {
    searchText: id,
    addressSet: [
      updateId
        ? {
            cadAddressType: "BUSINESS",
            cadId: updateId,
            cadCity: "",
            isRemove: 0,
            ...data
          }
        : {
            cadAddressType: "BUSINESS",
            cadCity: "",
            isRemove: 0,
            ...data
          }
    ]
  };
  const res = axios
    .post(`${CRM_BASE_URL}/address/update`, payload, { headers })
    .then(
      (res) => {
        if (res.status === 200) {
          return true;
        }
        return false;
      },
      (rejected) => console.warn(rejected)
    )
    .catch((error) => console.warn(error));
  return res;
};
export const deleteBusinessProfile = (id, cudId) => {
  const headers = getHeaderData();
  const res = axios
    .post(
      `${CRM_BASE_URL}/address/update`,
      {
        searchText: id,
        addressSet: [
          {
            cadId: cudId,
            cadAddressType: "BUSINESS",
            isRemove: 1
          }
        ]
      },
      { headers }
    )
    .then(
      (res) => {
        if (res.status === 200) {
          return true;
        }
        return false;
      },
      (rejected) => console.warn(rejected)
    )
    .catch((error) => console.warn(error));
  return res;
};

export const searchCustomer = (key, value) => {
  const headers = getHeaderData();
  const response = axios
    .get(`${CRM_SEARCH_CUSTOMER}/${key}/${value}`, { headers })
    .then(
      (res) => res.data.data[0],
      (rejected) => console.warn(rejected)
    )
    .catch((error) => console.warn(error));

  return response;
};

export const createGuestProfile = (data) => {
  const headers = getHeaderData();
  const params = { ...data, userType: "GUEST" };
  const response = axios
    .post(`${SAVE_GUEST_USER_IN_CRM}`, params, { headers })
    .then(
      (res) => res?.data,
      (rejected) => console.warn(rejected)
    )
    .catch((error) => console.warn(error));
  return response;
};

export const updateWhatsappPreference = (id, value) => {
  const headers = getHeaderData();
  headers.crm_id = id;
  const response = axios
    .post(
      `${CRM_BASE_URL}/detail/update`,
      {
        cusCustomerNo: id,
        cusAttrs: {
          CP_CHANNEL_WHATSAPP_ENABLED: value.toString()
        }
      },
      { headers }
    )
    .then(
      (res) => res,
      (rejected) => console.warn(rejected)
    )
    .catch((error) => console.warn(error));

  return response;
};

export const updateUserPreferenceForPromotion = (id: string, status: boolean, promotionChannel: string) => {
  const headers = getHeaderData();
  headers.crm_id = id;
  const response = axios
    .post(
      `${PROMOTION_PREFERENCE_FOR_USER}`,
      {
        customerNo: id,
        enabledPromotion: status,
        promotionChannel
      },
      { headers }
    )
    .then(
      (res) => res,
      (rejected) => console.warn(rejected)
    )
    .catch((error) => console.warn(error));

  return response;
};

export const addSubscriber = async (email) => {
  const headers = getHeaderData();
  let resp = {};

  const data = {
    email,
    channel: "WEB"
  };

  const config = {
    method: "put",
    url: NEWS_SUBSCRIBE,
    data
  };

  await axios(config)
    .then((response) => {
      resp = {
        status: 200,
        msg: "Email subscribed"
      };
    })
    .catch((error) => {
      console.warn(error);
    });

  return resp;
};
export const checkSubscriber = async (email) => {
  const headers = getHeaderData();
  const filter = `filter=USER_REF_FILTER&startDate=2002-07-01&endDate=${moment().format(
    "YYYY-MM-DD"
  )}&userRef=${email}&logType=TRACKING_EVENTS&action=NEWSLETTER_SUBSCRIBED&page.page=1&page.size=100&cacheVal=${Date.now()}`;
  let resp = false;
  await axios
    .get(`${CRM_EVENTLOG}/search?${filter}`, { headers })
    .then(
      (res) => {
        if (res.data.totalelements > 0) {
          resp = true;
        }
        // return res;
      },
      (rejected) => console.warn(rejected)
    )
    .catch((error) => console.warn(error));

  return resp;
};
